export default from './post-video-embed';



// WEBPACK FOOTER //
// ./app/components/post-video-embed/index.js